<div
  #tooltip="matTooltip"
  (click)="tooltip.show()"
  [ngClass]="ratingCustomClass"
  class="rating"
  matTooltip="{{ label }}: {{ rateToDisplay }}"
  matTooltipClass="varden-tooltip"
  matTooltipPosition="above"
>
  <app-ui-icon *ngFor="let icon of heartsArray; trackBy: trackByFn" [name]="icon" color="var(--apricot-1)"
            size="sm"></app-ui-icon>
</div>
